<template>
  <div>

    <!-- SOUNDCLOUD -->
    <template v-if="attachment.type === 'soundcloud'">
      <v-btn
        :href="attachment.path"
        target="_blank"
        tile
        outlined
        color="deep-orange"
        class="ma-2"
      >
        <v-icon left>mdi-soundcloud</v-icon>
        مرفق رقم {{ attachment.id }}
      </v-btn>
    </template>

    <!-- VIDEO -->
    <template v-if="attachment.type === 'video'">
      <iframe
        width="100%"
        height="250px"
        :src="attachment.path.replace('watch?v=', 'embed/')"
      ></iframe>
    </template>

    <!-- IMAGE -->
    <template v-if="attachment.type === 'image'">
      <img width="100%" :src="attachment.path" />
    </template>

    <!-- PDF -->
    <template v-if="attachment.type === 'pdf'">
      <v-btn
        :href="attachment.path && attachment.path.view"
        target="_blank"
        tile
        outlined
        color="red"
        class="ma-2"
      >
        <v-icon left>mdi-file-pdf-box</v-icon>
        مرفق رقم {{ attachment.id }}
      </v-btn>
    </template>

    <!-- OTHER -->
    <template v-if="attachment.type === 'other'">
      <v-btn
        :href="attachment.path"
        target="_blank"
        tile
        outlined
        color="info"
        class="ma-2"
      >
        <v-icon left>mdi-card-text</v-icon>
        مرفق رقم {{ attachment.id }}
      </v-btn>
    </template>

  </div>
</template>


<script>
export default {
  name: 'attachment-view',
  props: ['attachment'],


  computed: {
    
  }
}
</script>